import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

import request from '@/utils/request';
import { Notification, MessageBox, Message, Loading } from 'element-ui'

export function getToken() {

  return window.localStorage.getItem(TokenKey)
  // return Cookies.get(TokenKey)
}

export function setToken(token) {
  // return Cookies.set(TokenKey, token)
  window.localStorage.setItem(TokenKey,token)
}

export function removeToken() {
  // window.localStorage.removeItem(TokenKey)
  // return Cookies.remove(TokenKey)
  return window.localStorage.removeItem(TokenKey)
}
// 下载文件流 json
export function JsonDownload(url,data,filename,method = 'post'){
  let downloadLoadingInstance = Loading.service({ text: "正在下载数据，请稍候", spinner: "el-icon-loading", background: "rgba(0, 0, 0, 0.7)", })
  request({
    url: url,
    method: method,
    responseType: 'blob',
    data: data
  }).then(response => {
    downloadLoadingInstance.close();
    const blob = new Blob([response]);
    const fileName = filename;//自定义名字
    const linkNode = document.createElement("a");
    linkNode.download = fileName; //a标签的download属性规定下载文件的名称
    linkNode.style.display = "none";
    linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
    document.body.appendChild(linkNode);
    linkNode.click(); //模拟在按钮上的一次鼠标单击
    URL.revokeObjectURL(linkNode.href); // 释放URL 对象
    document.body.removeChild(linkNode);
  }).catch(() => {
    downloadLoadingInstance.close();
  })

}